import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocationStore } from '../..';
import useInsightsShape from '../../hooks/useInsightsShape';
import useLocationsInsideShape from '../../hooks/useLocationsInsideShape';
import useLocationsWithGlobalFilters from '../../hooks/useLocationsWithGlobalFilters';
import { IDetailsTabProps } from '../../interfaces/IDetailsTabProps';
import LocationsGrid from '../locations/LocationsGrid';

function InsightsCompaniesTab({ visible, setEntityCount }: IDetailsTabProps) {
    const locationStore = useLocationStore();
    const insightsShape = useInsightsShape();
    const locations = useLocationsWithGlobalFilters(useLocationsInsideShape(locationStore.locations, insightsShape));

    useEffect(() => setEntityCount(locations.length), [locations]);

    useEffect(() => {
        if (visible)
            locationStore.setRadiusLocationIds(locations.map(l => l.id));
        else
            locationStore.setRadiusLocationIds([]);

        return () => locationStore.setRadiusLocationIds([]);
    }, [visible, locations]);

    if (!visible || !insightsShape)
        return null;

    return (
        <LocationsGrid locations={locations} />
    );
}

export default observer(InsightsCompaniesTab);
